/* The customer's own design as the cart line's picture. The product page saves its preview (a small
   JPEG) in this browser just before the piece is added, keyed by the line it will make: the variant and
   the public properties (names, font, stone…). Wherever cart lines are shown (drawer, the "added"
   popup, the cart page) the supplier's photograph of that line is replaced by the saved design.
   Nothing is uploaded; another browser simply shows the product photograph. */
(() => {
  const KEY = 'auriani:line-images:v1', MAX = 24;
  const publicProps = props => Object.entries(props || {}).filter(([k, v]) => !k.startsWith('_') && v !== '' && v != null)
    .map(([k, v]) => [k, String(v)]).sort(([a], [b]) => a.localeCompare(b));
  const lineKey = (variantId, props) => JSON.stringify([String(variantId), publicProps(props)]);
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (_) { return {}; } };
  function save(variantId, props, dataUrl) {
    if (!/^data:image\/(jpeg|png|webp);base64,/.test(dataUrl || '')) return;
    const all = read();
    all[lineKey(variantId, props)] = {img: dataUrl, t: Date.now()};
    const keep = Object.entries(all).sort((a, b) => b[1].t - a[1].t).slice(0, MAX);
    try { localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(keep))); } catch (_) {
      // storage full: keep only this one
      try { localStorage.setItem(KEY, JSON.stringify({[lineKey(variantId, props)]: {img: dataUrl, t: Date.now()}})); } catch (_) {}
    }
    apply();
  }
  const get = (variantId, props) => read()[lineKey(variantId, props)]?.img || null;

  function cartItems() {
    const items = new Map();
    document.querySelectorAll('[data-cart-state]').forEach(el => {
      try { (JSON.parse(el.textContent).items || []).forEach(item => items.set(item.key, item)); } catch (_) {}
    });
    return items;
  }
  function apply() {
    const items = cartItems();
    document.querySelectorAll('[data-cart-line]').forEach(row => {
      const item = items.get(row.dataset.lineKey);
      if (!item) return;
      const img = get(item.variant_id, item.properties);
      if (!img) return;
      const holder = row.querySelector('.cart-line__image');
      if (!holder) return;
      const old = holder.querySelector('img');
      if (old && old.dataset.ownDesign === '1' && old.getAttribute('src') === img) return;
      // a new element: a browser keeps the srcset candidate it chose even after src changes
      const pic = document.createElement('img');
      pic.src = img; pic.loading = 'eager'; pic.decoding = 'async';
      if (old) old.replaceWith(pic); else { holder.textContent = ''; holder.appendChild(pic); }
      pic.width = 320; pic.height = 320;
      const words = publicProps(item.properties).filter(([k]) => !/font|style/i.test(k)).map(([, v]) => v);
      pic.alt = `Your design: ${item.product_title}${words.length ? ' — ' + words.join(', ') : ''}`;
      pic.dataset.ownDesign = '1';
      pic.style.objectFit = 'contain';
      pic.style.background = '#fff';
    });
  }
  window.AurianiLineImages = Object.freeze({save, get, apply});
  document.addEventListener('auriani:cart-changed', () => setTimeout(apply, 0));
  document.addEventListener('shopify:section:load', apply);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  // Regions are replaced when the cart repaints; catch any repaint the event does not announce.
  let queued = false;
  // (a timer, not an animation frame: frames pause in a hidden tab, and the drawer can open in one)
  new MutationObserver(() => { if (queued) return; queued = true; setTimeout(() => { queued = false; apply(); }, 30); })
    .observe(document.documentElement, {childList: true, subtree: true});
})();
